module.exports = __webpack_public_path__ + "static/media/rpg-dice-js.d5c51735.png";